export default __webpack_public_path__ + "static/media/step-3-complete.ea6d03b1.svg";